import i18n from "i18next";

const pad = (n: number) => String(n).padStart(2, "0");

const isSR = (): boolean => {
  // i18next ima samo "EN" i "SR" resurse, fallbackLng = "SR".
  // Sve sto nije eksplicitno "EN" pada na SR (i prevodi i format).
  return i18n.language !== "EN";
};

/**
 * Lokalno vreme (za uplate, treninge, holiday-e, realni momenat).
 * SR → DD.MM.YYYY.   EN → M/D/YYYY
 */
export const formatDate = (input: string | Date | number): string => {
  const d = new Date(input);
  if (isSR()) {
    return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}.`;
  }
  return d.toLocaleDateString("en-US");
};

export const formatTime = (input: string | Date | number): string => {
  const d = new Date(input);
  if (isSR()) {
    return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }
  return d.toLocaleTimeString("en-US", {hour: "2-digit", minute: "2-digit"});
};

export const formatDateTime = (input: string | Date | number): string => {
  const d = new Date(input);
  if (isSR()) {
    return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}. u ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }
  return d.toLocaleString("en-US", {
    day: "numeric",
    month: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatLongDate = (input: string | Date | number): string => {
  const d = new Date(input);
  if (isSR()) {
    const day = d.toLocaleDateString("sr-Latn", {weekday: "long"});
    return `${day.charAt(0).toUpperCase() + day.slice(1)}, ${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}.`;
  }
  return d.toLocaleDateString("en-US", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

/**
 * "Wall clock" UTC vreme (za bookings, trener kaze "termin u 9h",
 * cuva se kao 09:00 UTC u bazi i mora se prikazati kao 09:00 svuda).
 */
export const formatBookingTime = (input: string | Date | number): string => {
  const d = new Date(input);
  if (isSR()) {
    return `${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}`;
  }
  return d.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "UTC",
  });
};

export const formatBookingDate = (input: string | Date | number): string => {
  const d = new Date(input);
  if (isSR()) {
    return `${pad(d.getUTCDate())}.${pad(d.getUTCMonth() + 1)}.${d.getUTCFullYear()}.`;
  }
  return d.toLocaleDateString("en-US", {timeZone: "UTC"});
};

/**
 * Ključ kalendarskog dana za termin: Booking.date je "wall clock" u UTC
 * polju, pa se dan čita UTC getterima - nezavisno od vremenske zone
 * telefona. Lokalno grupisanje bi termin posle 22h (ili za korisnika u
 * drugoj zoni) prikazalo pod pogrešnim danom.
 */
export const bookingDayKey = (input: string | Date | number): string => {
  const d = new Date(input);
  return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}`;
};

/** Ključ dana za polje kalendarske mreže (lokalni Date iz react-calendar). */
export const calendarDayKey = (date: Date): string =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

/**
 * "YYYY-MM-DD" iz <input type="date"> u pravi trenutak LOKALNE ponoći tog
 * dana. Sam string bi se parsirao kao UTC ponoć, pa bi granice opsega
 * (pregled uplata, stopiranja) bežale 1-2h od stvarnog lokalnog dana.
 */
export const localDayStartISO = (day: string): string =>
  new Date(`${day}T00:00:00`).toISOString();

export const formatBookingLongDate = (input: string | Date | number): string => {
  const d = new Date(input);
  if (isSR()) {
    const day = d.toLocaleDateString("sr-Latn", {weekday: "long", timeZone: "UTC"});
    return `${day.charAt(0).toUpperCase() + day.slice(1)}, ${pad(d.getUTCDate())}.${pad(d.getUTCMonth() + 1)}.${d.getUTCFullYear()}.`;
  }
  return d.toLocaleDateString("en-US", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  });
};
